// Bare: "Does Bare fit your routine?" — a small pairing-information tool,
// not a diagnostic or medical-advice tool. General, non-prescriptive
// guidance only; always defers to a dermatologist for anything specific.
(function () {
  const GUIDANCE = {
    tretinoin:
      "Bare is a cleanser, so it comes before your tretinoin, not instead of it. Many people find a gentle, non-stripping cleanse in the routine easier on skin that's adjusting to a retinoid — but timing and frequency with tretinoin is worth confirming with whoever prescribed it.",
    benzoyl:
      "Bare cleanses without added actives, so it won't interact with benzoyl peroxide — it's simply a wash before you apply it. If your skin feels dry or tight from benzoyl peroxide, a non-stripping cleanse is generally a reasonable pairing, but check with a dermatologist if irritation continues.",
    adapalene:
      "Bare is designed to sit before adapalene in a routine, not alongside or instead of it. As with any retinoid, how your skin responds is individual — a gentle, fragrance-free cleanse is a common pairing, but your dermatologist's guidance on frequency should take priority.",
    salicylic:
      "Bare doesn't contain additional exfoliating acids, so it won't stack with your salicylic acid product. It's simply meant to be the cleansing step before it.",
    none: "Bare is built to be a simple first step — a gentle daily cleanser you can build a routine around, whatever comes next.",
  };

  const select = document.querySelector('[data-bare-compat-select]');
  const resultWrap = document.querySelector('[data-bare-compat-result]');
  const resultText = document.querySelector('[data-bare-compat-text]');
  if (!select || !resultWrap || !resultText) return;

  select.addEventListener('change', () => {
    const value = select.value;
    if (!value || !GUIDANCE[value]) {
      resultWrap.hidden = true;
      return;
    }
    resultText.textContent = GUIDANCE[value];
    resultWrap.hidden = false;
  });
})();
